// Define unique string identifiers for each action type
export const SET_INVENTORY_FILTERS = 'SET_INVENTORY_FILTERS';
export const SET_INVENTORY_DATE_RANGE = 'SET_INVENTORY_DATE_RANGE';
export const SET_INVENTORY_DATA = 'SET_INVENTORY_DATA';
export const CLEAR_INVENTORY_STATE = 'CLEAR_INVENTORY_STATE';


// Creates an action object to update filters in Redux store
export const setInventoryFilters = (filters: any[]) => ({
  type: SET_INVENTORY_FILTERS,
  payload: filters,
});

export const setInventoryDateRange = (dateRange: [string, string] | null) => ({
  type: SET_INVENTORY_DATE_RANGE,
  payload: dateRange,
});

export const setInventoryData = (data: any) => ({
  type: SET_INVENTORY_DATA,
  payload: data,
});

export const clearInventoryState = () => ({
  type: CLEAR_INVENTORY_STATE,
});